export const SMARTLIB_LOG_LEVEL = {
    DEBUG: 1,
    INFO: 0,
    NO_LOGS: -1,
} as const;

export const CDN = {
    AKAMAI: 'AKAMAI',
    BROADPEAK: 'BROADPEAK',
} as const;
